module.exports = __webpack_public_path__ + "img/taobao.4d8f91e9.jpg";